var map = {
	"./bill_huang.jpg": "nz6S",
	"./bill_huang_cert.jpg": "1Giy",
	"./derek_lai.jpg": "asA4",
	"./guoping_yang.jpg": "paK7",
	"./guoxiang_wang.jpg": "E+bb",
	"./guoxiang_wang_cert.jpg": "kLCv",
	"./nini_wu.jpg": "fp/2",
	"./nini_wu_cert.jpg": "EgjW",
	"./nuxin_fu.jpg": "dxC2",
	"./ping_chen.jpg": "Y0gb",
	"./quan_jiang.jpg": "jGqX",
	"./quan_jiang_2.jpg": "qFrY",
	"./stephen_chiu.jpg": "B0lX",
	"./winnie_lai.jpg": "JJjs",
	"./yi_xiao.jpg": "GO9L",
	"./yinghua_huang.jpg": "bONA",
	"./yonggang_xiong_cert.jpg": "N8pC",
	"./yue_zhang.jpg": "CyI3",
	"./yue_zhang_2.jpg": "M733",
	"./yuehui_zhang.jpg": "cvvX"
};
function webpackContext(req) {
	return __webpack_require__(webpackContextResolve(req));
};
function webpackContextResolve(req) {
	var id = map[req];
	if(!(id + 1)) // check for number or string
		throw new Error("Cannot find module '" + req + "'.");
	return id;
};
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "ce0V";


//////////////////
// WEBPACK FOOTER
// ./src/assets/wmm ^\.\/.*$
// module id = ce0V
// module chunks = 0